import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Formik, Form } from 'formik';
import Loader from 'features/Loader/Loader';
import TextField from 'shared/components/text-field/TextField';
import CheckBox from 'shared/components/check-box/CheckBox';
import Button from 'shared/components/button/Button';
import { editProfileSchema } from 'utils/validators/editProfile';
import {
  updateTrainer,
  getFocusAreas
} from '../../trainer/profile/ducks/trainerProfileActions';

const CreateForm = props => {
  const { trainer, focusAreasData, history } = props;

  let {
    id,
    first_name,
    last_name,
    photo,
    certifications,
    focus_areas
  } = trainer;

  let initials =
    first_name && last_name
      ? `${first_name[0].toUpperCase()}${last_name[0].toUpperCase()}`
      : '';

  let upload = null;

  //component did mount
  useEffect(() => {
    props.getFocusAreas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        first_name: first_name,
        last_name: last_name,
        photo: null,
        photoUrl: photo || '',
        certifications: certifications || '',
        focus_areas: focus_areas || []
      }}
      onSubmit={values => {
        let submittedValues = { ...values, id: id };
        Object.keys(submittedValues).forEach(key =>
          submittedValues[key] === (undefined || null) || key === 'photoUrl'
            ? delete submittedValues[key]
            : ''
        );
        return props.updateTrainer({ ...submittedValues }, history);
      }}
      validationSchema={editProfileSchema}
    >
      {formik => (
        <Form>
          {formik.isSubmitting ? (
            <Loader />
          ) : (
            <span>
              <div className="form-side">
                <div className="form-content">
                  <div className="form-avatar">
                    <div className="user-avatar">
                      {formik.values.photoUrl ? (
                        <img src={formik.values.photoUrl} alt="" />
                      ) : (
                        <i>{initials}</i>
                      )}
                    </div>

                    <input
                      id="submit-btn"
                      name="photo"
                      type="file"
                      accept="image/*"
                      onChange={event => {
                        formik.setFieldValue(
                          'photo',
                          event.currentTarget.files[0]
                        );
                        formik.setFieldValue(
                          'photoUrl',
                          URL.createObjectURL(event.currentTarget.files[0])
                        );
                      }}
                      className="form-control"
                      color="primary"
                      label="Edit Profile Photo"
                      ref={ref => (upload = ref)}
                      style={{ display: 'none' }}
                    />
                    <Button
                      color="light"
                      label="Edit Profile Photo"
                      onClick={event => {
                        event.preventDefault();
                        upload.click();
                      }}
                    />
                  </div>

                  <div className="form-row">
                    <div className="col">
                      <TextField
                        type="text"
                        name="first_name"
                        label="First Name"
                        placeholder="First Name"
                      />
                    </div>

                    <div className="col">
                      <TextField
                        type="text"
                        name="last_name"
                        label="Last Name"
                        placeholder="Last Name"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Certifications</label>
                    <textarea
                      name="certifications"
                      className="form-control"
                      placeholder="Tell clients about yourself"
                      value={formik.values.certifications}
                      onChange={formik.handleChange}
                    />
                  </div>

                  <div className="form-group focus-area-options">
                    <label className="form-label">Focus Areas</label>
                    <div className="form-row">
                      {(focusAreasData
                        ? Object.keys(focusAreasData.values)
                        : []
                      ).map(key => {
                        return (
                          <CheckBox
                            key={key}
                            value={key}
                            id={key}
                            text={focusAreasData.values[key].value}
                            name="focus_areas"
                          />
                        );
                      })}
                    </div>
                  </div>

                  <div className="form-action">
                    <Button
                      id="submit-btn"
                      type="submit"
                      color="primary"
                      label="Save Profile"
                    />
                  </div>
                </div>
              </div>
            </span>
          )}
        </Form>
      )}
    </Formik>
  );
};

function mapStateToProps(state) {
  return {
    trainer: state.trainerProfileReducer.trainer,
    focusAreasData: state.trainerProfileReducer.focusAreas
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateTrainer: (values, history) =>
      dispatch(updateTrainer(values, history)),
    getFocusAreas: () => dispatch(getFocusAreas())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CreateForm));
